import { t } from '../../../../shared';
import { States } from '../../../utils';
export const mailingFormMap = [{
  label: 'residences.mailing.street',
  displayName: 'STREET ADDRESS',
  type: 'text'
}, {
  label: 'residences.mailing.unit',
  displayName: 'UNIT NUMBER',
  type: 'text',
  maxLength: 8
}, {
  label: 'residences.mailing.cityName',
  displayName: 'CITY',
  type: 'text'
}, {
  label: 'residences.mailing.stateCode',
  displayName: 'STATE',
  type: 'dropdown',
  options: States,
  formateType: 'stateCode'
}, {
  label: 'residences.mailing.postalCode',
  displayName: 'ZIP CODE',
  type: 'text',
  maxLength: 5,
  keyboardType: 'number-pad'
}];
export const presentFormMap = [{
  label: 'residences.present.street',
  displayName: 'STREET ADDRESS',
  type: 'text',
  maxLength: 35
}, {
  label: 'residences.present.unit',
  displayName: 'UNIT NUMBER',
  type: 'text',
  maxLength: 8
}, {
  label: 'residences.present.cityName',
  displayName: 'CITY',
  type: 'text',
  maxLength: 35
}, {
  label: 'residences.present.stateCode',
  displayName: 'STATE',
  type: 'dropdown',
  options: t('STATES', {
    returnObjects: true
  }),
  formateType: 'stateCode'
}, {
  label: 'residences.present.postalCode',
  displayName: 'ZIP CODE',
  type: 'text',
  maxLength: 5,
  keyboardType: 'number-pad'
}, {
  label: 'residences.present.housingExpenseType',
  displayName: 'OWN/RENT',
  type: 'dropdown',
  options: t('RESIDENCY_TYPE', {
    returnObjects: true
  })
}, {
  label: 'residences.present.housingExpensePaymentAmount',
  displayName: 'RENT PER MONTH',
  type: 'currency',
  maxLength: 14
}, {
  label: 'residences.present.borrowerResidencyDurationYearsCount',
  displayName: 'YEARS AT THIS ADDRESS',
  type: 'number',
  maxLength: 2,
  keyboardType: 'number-pad'
}, {
  label: 'residences.present.borrowerResidencyDurationMonthsCount',
  displayName: 'MONTHS AT THIS ADDRESS',
  type: 'number',
  maxLength: 2,
  maxValue: 11,
  keyboardType: 'number-pad'
}];
export const previousFormMap = {
  street: {
    label: 'residences.previous.street',
    displayName: 'STREET ADDRESS',
    type: 'text'
  },
  unit: {
    label: 'residences.previous.unit',
    displayName: 'UNIT NUMBER',
    type: 'text',
    maxLength: 8
  },
  cityName: {
    label: 'residences.previous.cityName',
    displayName: 'CITY',
    type: 'text'
  },
  stateCode: {
    label: 'residences.previous.stateCode',
    displayName: 'STATE',
    type: 'dropdown',
    options: States,
    formateType: 'stateCode'
  },
  postalCode: {
    label: 'residences.previous.postalCode',
    displayName: 'ZIP CODE',
    type: 'text',
    maxLength: 5,
    keyboardType: 'number-pad'
  },
  borrowerResidencyDurationYearsCount: {
    label: 'residences.previous.borrowerResidencyDurationYearsCount',
    displayName: 'YEARS AT THIS ADDRESS',
    type: 'number',
    maxLength: 2,
    keyboardType: 'number-pad'
  },
  borrowerResidencyDurationMonthsCount: {
    label: 'residences.previous.borrowerResidencyDurationMonthsCount',
    displayName: 'MONTHS AT THIS ADDRESS',
    type: 'number',
    maxValue: 11,
    maxLength: 2,
    keyboardType: 'number-pad'
  }
};
export const form = [{
  label: 'citizenshipResidencyType',
  displayName: 'CITIZENSHIP status',
  type: 'dropdown',
  options: t('CITIZENSHIP', {
    returnObjects: true
  })
}, {
  label: 'alternativeNames',
  displayName: 'ALTERNATIVE NAME',
  type: 'text',
  maxLength: 35
}, {
  label: 'dependentCount',
  displayName: 'DEPENDENTS',
  type: 'dropdown',
  options: t('DEPENDENTS', {
    returnObjects: true
  })
}];
export const formOthers = [{
  label: 'ssn',
  displayName: 'SOCIAL SECURITY NUMBER',
  type: 'ssn'
}, {
  label: 'borrowerBirthDate',
  displayName: 'DATE OF BIRTH',
  type: 'date'
}];
export const presentAddress = {
  sameAsPropertyAddress: '',
  street: '',
  unit: '',
  cityName: '',
  stateCode: '',
  postalCode: '',
  housingExpenseType: '',
  housingExpensePaymentAmount: '',
  borrowerResidencyDurationYearsCount: 0,
  borrowerResidencyDurationMonthsCount: 0
};
export const mailingAddress = {
  sameAsPropertyAddress: '',
  street: '',
  unit: '',
  cityName: '',
  stateCode: '',
  postalCode: ''
};
export const previousAddressOrder = {
  street: '',
  unit: '',
  cityName: '',
  stateCode: '',
  postalCode: '',
  borrowerResidencyDurationYearsCount: 0,
  borrowerResidencyDurationMonthsCount: 0
};
//# sourceMappingURL=helpers.js.map